<template>
	<div class="m-1">
		<b-modal ref="publish-modal" size="mg" id="modal-center" centered hide-footer  >
			<div class="d-flex justify-content-center">
				<img src="../assets/banklist.jpg" style="width: 80%;"  >
			</div>
		</b-modal>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				repayInfo:null,
			}
		},

		methods: {
			showModal() {
	
				this.$refs['publish-modal'].show()
			},
			
			hideModal() {
				this.$refs['publish-modal'].hide()
			},
		
		}
	}
</script>

<style>
	#item:hover {
		background-color:gainsboro;
		border-radius: 5px;
	}
	
</style>
